let configPromise;

function resolveConfig() {
  if (process.env.REACT_APP_BACKEND_URL) {
    // Dev fallback: yarn start works via .env with no config.json present.
    return Promise.resolve({ backendUrl: process.env.REACT_APP_BACKEND_URL });
  }
  return fetch("/config.json", { cache: "no-store" })
    .then((res) => {
      if (!res.ok) throw new Error(`config.json request failed: ${res.status}`);
      return res.json();
    })
    .then((data) => {
      if (!data || typeof data.backendUrl !== "string" || !data.backendUrl) {
        throw new Error("config.json is missing a valid backendUrl");
      }
      return data;
    });
}

export function getConfig() {
  if (!configPromise) {
    configPromise = resolveConfig().catch((err) => {
      console.error("Failed to load runtime config:", err);
      configPromise = undefined; // allow a retry on the next call
      throw err;
    });
  }
  return configPromise;
}

export async function getBackendUrl() {
  const config = await getConfig();
  return config.backendUrl;
}
